import { TRACKING_CONFIG } from '@/config/tracking.config'

declare global {
  interface Window {
    fbq: (
      action: string,
      eventName: string,
      options?: Record<string, unknown>,
    ) => void
  }
}
export const FB_PIXEL_ID: string = TRACKING_CONFIG.facebook.pixelId

export const pageview = (): void => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (
  name: string,
  options: Record<string, unknown> = {},
): void => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', name, options)
  }
}
